// Porta leve para `src/app` e `src/routes` (JS inicial): manifestos, schemas de busca, catálogo e o
// carregador das telas. Outro módulo usa a `public.ts`.
export { loadCreditNoteMessages } from './credit-note.catalog';
export { CREDIT_NOTE_TABS, creditNoteDetailScreen, creditNoteDetailSearch, type CreditNoteTab } from './credit-note-detail.screen';
export { CREDIT_NOTE_LIST_PATH, creditNoteListScreen } from './credit-note-list.screen';
export { creditNoteNewScreen, creditNoteNewSearch } from './credit-note-new.screen';
export { creditNoteListSearch } from './credit-note-list.search';

/** As telas, carregadas sob demanda pela rota. */
export const loadCreditNoteScreens = () => import('./screens');

/**
 * Cada tela no próprio chunk (R1 da !11138): a lista não carrega a barra do detalhe (`bar-*`), e o
 * detalhe não carrega a tabela da lista. O código comum sai num chunk compartilhado.
 */
export const loadCreditNoteListScreen = () => import('./screens/credit-note-list-screen');
export const loadCreditNoteDetailScreen = () => import('./screens/credit-note-detail-screen');
/** A Nova no próprio chunk: não carrega a lista nem o detalhe (B5 da Etapa 2). */
export const loadCreditNoteNewScreen = () => import('./screens/form-new-screen');

/** Os guias das telas para o Luy (U46), sob demanda. */
export const loadCreditNoteGuides = () => import('./credit-note.guide');
